module.exports = __webpack_public_path__ + "img/79.6b3b0225.jpg";